export default "__VITE_ASSET__BMoBtVuw__"